import React from "react";
import classnames from "classnames";

const TOOLTIP_POSITION = {
  default: "",
  left: "has-tooltip-left",
  right: "has-tooltip-right",
  bottom: "has-tooltip-bottom",
} as const;

/**
 * https://graffer.atlassian.net/browse/PRODUCTS-10226
 * Tooltipはアクセシビリティなどの観点から使用不可
 * 別の方法で代替すること
 * @deprecated
 */
export const DeprecatedTooltip: React.FC<{
  text: string;
  position?: "default" | "left" | "right" | "bottom";
}> = ({ text, position = "default" }) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a
    className={classnames("tooltip is-tooltip-top", TOOLTIP_POSITION[position])}
    data-tooltip={text}
  >
    <i className="fas fa-question-circle"></i>
  </a>
);
